import tw from 'twin.macro'
import React, { useContext } from 'react'
import { MCOnboardingsContext } from '../mc-onboardings/MCOnboardings.context'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { MCOnboardingsTableContext } from '../mc-onboardings-table/MCOnboardingsTable.context'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'

export const MCOnboardingsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(MCOnboardingsContext)
  const {
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(MCOnboardingsTableContext)

  return (
    <div
      css={tw`flex flex-row items-center gap-4 bg-white px-4 py-3 border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      {columnsConfig.length > 0 && (
        <GridColumnsSelect
          columnsConfig={columnsConfig}
          columnVisibilityModel={columnVisibilityModel}
          pinnedColumns={pinnedColumns}
          lockedColumns={lockedColumns}
          onToggleColumnVisibility={onToggleColumnVisibility}
          onColumnVisibilityModelChange={onColumnVisibilityModelChange}
          onPinColumn={onPinColumn}
          onUnpinColumn={onUnpinColumn}
        />
      )}
      <TableSearch
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        inputDataTestId="master-contractors-onboarding-list-search-input"
        clearButtonDataTestId="master-contractors-onboarding-list-search-clear-btn"
      />
    </div>
  )
}
